module.exports = __webpack_public_path__ + "img/horizontal_3_3_r_pp3_8019.fd87b0b0.png";